window.storeTheme = window.storeTheme || ({} as StoreTheme);

function Cart() {
  const $window = $(window);
  const $document = $(document);
  const $wrapper = $document.find('.cart-trigger');
  const template = $wrapper.find('script[data-id=widget-cart-template]').text();
  const previewTemplate = $wrapper.find('script[data-id=widget-cart-preview-template]').text();
  let couponMessage = '';

  const init = async () => {
    window.storeTheme.helpers.mustache.parse(template);
    window.storeTheme.helpers.mustache.parse(previewTemplate);

    await getRemoteOrderForm(); // TODO: validar necessidade de realmente logo ao iniciar o conteúdo. Devemos aproveitar as infos já existentes na página e só chamar isso se o cliente interagir com o carrinho
    bindHtmlTriggers();
    checkCoupon();
    render();
    renderPreview();
    $window.on('checkoutRequestBegin.vtex', showLoader);
    $window.on('checkoutRequestEnd.vtex', checkCoupon);
    $window.on('orderFormUpdated.vtex', debounce(render, 100));
    $window.on('orderFormUpdated.vtex', debounce(renderPreview, 100));
    $window.on('openWidgetCart', openPreview);
  };

  /** class helpers */
  const getRemoteOrderForm = async () => vtexjs.checkout.getOrderForm();
  const debounce = (fn, time) => window.storeTheme.helpers.debounce(fn, time);
  const money = (value) => window.storeTheme.helpers.format.money(value, false);
  const showLoader = () => $wrapper.addClass('cart-loading');
  const hideLoader = () => $wrapper.removeClass('cart-loading');
  const togglePreviewEvent = (e) => {
    e.preventDefault();
    togglePreview();
  };

  function hideAlert(event) {
    const $e = $(event.currentTarget);
    $e.closest('.alert').slideUp();
  }

  /** private methods */
  function bindHtmlTriggers() {
    $wrapper.on('click', '.cart-close', togglePreviewEvent);
    $wrapper.on('click', '[data-bs-dismiss="alert"]', hideAlert);
    $wrapper.find('a.cart-preview').on('click', togglePreviewEvent);
    $wrapper.find('.cart-preview-mod').on('click', togglePreviewEvent);
  }

  function bindHtmlDynamicTriggers() {
    $wrapper.find('.continue-shop').on('click', togglePreviewEvent);
    $wrapper.find('.coupon-wrap .clear-coupon').on('click', removeCoupon);
    $wrapper.find('.coupon-wrap #click-to-add').on('click', openCoupon);
    $wrapper.find('.cart-body .delete-item').on('click', onDeleteItemClick);
  }

  function togglePreview() {
    $wrapper.toggleClass('cart-open');
  }

  function openPreview() {
    $wrapper.addClass('cart-open');
  }

  /**
   * Limpar mensagens de alerta do carrinho
   */
  const clearMessages = async () => {
    await window.vtexjs.checkout.clearMessages();
  };

  async function removeItem(uniqueId, index) {
    const result = await vtexjs.checkout.removeItems([{ index, uniqueId }]);

    if (result?.messages?.length) {
      console.warn('❗️ removeItemFromCart status for debug: ', result?.messages);
    }

    const $dom = $wrapper.find(`.cart-item[data-id="${uniqueId}"]`);

    $dom.slideUp(200, () => $dom.remove());
  }

  const checkCoupon = async () => {
    const orderForm = await getRemoteOrderForm();
    const coupon = orderForm?.marketingData?.coupon || '';
    const $wrap = $('.coupon-wrap');
    if (coupon === '') {
      $wrap.addClass('dashed');
    }
    return coupon;
  };

  const openCoupon = () => {
    const $btnHidden = $('#click-to-add').addClass('d-none');
    const $elToShow = $('.apply-coupon');
    const $wrap = $('.coupon-wrap');
    $wrap.removeClass('dashed');
    $('.coupon-msg').html('');
    $elToShow.removeClass('d-none');
    applyCoupon();
  };

  const applyCoupon = async () => {
    const $wrapEl = $('.apply-coupon');
    const $codeInput = $wrapEl.find('#coupon');
    const $btnApply = $wrapEl.find('#add-coupon');
    $btnApply.on('click', async (e) => {
      e.preventDefault();
      const inputValue = $codeInput.val() != '' && (await couponValidate($codeInput.val()));
    });
  };
  const couponValidate = async (inputValue) => {
    const addCoupon = await vtexjs.checkout.addDiscountCoupon(inputValue).then(function (orderForm) {
      const objOrderForm = orderForm;
      const message = objOrderForm.messages.find((item) => item.code === 'couponNotFound')
        ? objOrderForm.messages.filter((item) => item.code === 'couponNotFound')[0].text
        : '';
      if (message != '') {
        couponMessage = 'Cupom inválido.';
      } else {
        couponMessage = 'Cupom Aplicado.';
        couponApplied(objOrderForm.marketingData.coupon);
      }
    });
  };

  const removeCoupon = async () => {
    const result = await vtexjs.checkout
      .getOrderForm()
      .then(function (orderForm) {
        return vtexjs.checkout.removeDiscountCoupon();
      })
      .then(function (orderForm) {
        couponMessage = 'Cupom removido.';
      });
  };

  const couponApplied = async (coupon) => {
    const lastStep = $('.apply-coupon');
    const couponApplied = $('.coupon-applied');
    couponApplied.removeClass('d-none');
    lastStep.addClass('d-none');
    couponApplied.find('.coupon-applied-name').html(coupon);
  };

  async function render() {
    const totalizers = vtexjs.checkout.orderForm?.totalizers;
    const subtotal = totalizers?.find((items) => items.id === 'Items')?.value / 100 || 0;
    const discounts = totalizers?.find((items) => items.id === 'Discounts')?.value / 100 || 0;
    const total = subtotal + discounts;
    const subtotalFormated = money(subtotal);
    const discountsFormated = money(discounts);
    const totalFormated = money(total);
    const couponName = vtexjs.checkout.orderForm?.marketingData?.coupon;
    const couponMsg = couponMessage;
    const itemsCount = vtexjs.checkout.orderForm?.items?.length;
    const itemsCountText = itemsCount === 1 ? 'Item' : 'Itens';
    const $shippingMsg = $('.progress-free-shipping').find('.msg-barra-frete');
    const $initialMsg = $shippingMsg.find('.msg-inicial').text();
    const $incompleteMsg = $shippingMsg.find('.msg-progresso-incompleto').text();
    const $completeMsg = $shippingMsg.find('.msg-progresso-completo').text();
    let $price = $shippingMsg.find('.preco-max').text().substring(3);
    $price = $price.replace(',', '.');

    showLoader();
    let percentProgressShipping = (100 / $price) * (vtexjs.checkout.orderForm?.value / 100);
    let textProgressShipping = '';
    switch (true) {
      case percentProgressShipping == 0:
        textProgressShipping = $initialMsg;
        break;
      case percentProgressShipping > 0 && percentProgressShipping < 100:
        textProgressShipping =
          'Falta R$' +
          ($price - vtexjs.checkout.orderForm?.value / 100).toFixed(2).replace('.', ',') +
          ' ' +
          $incompleteMsg;
        break;
      case percentProgressShipping == 100 || percentProgressShipping > 100:
        percentProgressShipping = percentProgressShipping + 100;
        textProgressShipping = $completeMsg;
        break;
    }
    $('.progress-free-shipping')
      .find('span.text')
      .html(' ' + textProgressShipping);
    $('.progress-bar-menu')
      .find('.progress-bar')
      .attr('style', ' width:' + percentProgressShipping.toFixed(2) + '%')
      .attr('data-valuenow', percentProgressShipping.toFixed(2) + '%');

    const skus = vtexjs.checkout.orderForm?.items.map(({ productId }) => productId);
    const details = await window.storeTheme.helpers.getSkuInfoByProductList(skus, 'productId');
    const products = vtexjs.checkout.orderForm?.items?.map((item, index) => ({
      index,
      customMeasureValue: details[item.productId]?.customMeasureValue,
      customMeasureType: details[item.productId]?.customMeasureType,
      customMeasureTypeClean: details[item.productId]?.customMeasureTypeClean,
      detailUrl: item.detailUrl,
      id: item.uniqueId,
      imageUrl: item.imageUrl.replace('-172-114', '-100-100'),
      measurementUnit: item.measurementUnit,
      name: item.name,
      price: money(item.sellingPrice / 100),
      quantity: item.quantity,
      cannotBeDelivered: item.availability === 'cannotBeDelivered',
      origin: item,
    }));

    if (vtexjs.checkout.orderForm.messages.length) {
      clearMessages();
    }

    const html = window.storeTheme.helpers.mustache.render(template, {
      couponName,
      subtotalFormated,
      discountsFormated,
      totalFormated,
      percentProgressShipping,
      textProgressShipping,
      itemsCount,
      itemsCountText,
      products,
      couponMsg,
      messages: vtexjs.checkout.orderForm.messages.filter((msg) => {
        msg.code !== 'cannotBeDelivered';
      }),
    });
    $wrapper.find('.custom-cart').html(html);

    bindHtmlDynamicTriggers();
    hideLoader();
  }

  async function renderPreview() {
    const price = money(vtexjs.checkout.orderForm?.totalizers?.find((items) => items.id === 'Items')?.value / 100 || 0);
    const itemsCount = vtexjs.checkout.orderForm?.items?.length;
    const itemsCountText = itemsCount === 1 ? 'Item' : 'Itens';
    const html = window.storeTheme.helpers.mustache.render(previewTemplate, {
      price,
      text: `<span class="qty">${itemsCount}</span><span class="txt"> ${itemsCountText}</span>`,
    });

    $wrapper.find('.cart-preview-mod').html(html);

    if (itemsCount > 0) {
      $wrapper.addClass('cart-preview-on');
    } else {
      $wrapper.removeClass('cart-preview-on');
    }
  }

  /**
   * event handlers
   */
  function onDeleteItemClick(event) {
    event.preventDefault();
    const $item = $(event.currentTarget).closest('.cart-item');
    const id = $item.data('id');
    const index = $item.data('index');

    removeItem(id, index);
  }

  $document.ready(init);
}

Object.assign(window.storeTheme, { widgets: Object.assign(window.storeTheme.widgets || {}, { cart: new Cart() }) });

export default {};
